import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import GridItem from '../../../../kyc/kycPerson/components/GridItem'
import { CollapsibleSection } from '../CollapsibleSection'
import styles from './styles.module.scss'

export const ExtractedInformation = ({ vendorData }) => {
  const { t } = useTranslation(['common', 'messages'])

  if (!vendorData || !vendorData.id_verification) {
    return (
      <CollapsibleSection title={t('common:extractedInformation')}>
        <Typography variant="body2" color="textSecondary">
          {t('common:noData')}
        </Typography>
      </CollapsibleSection>
    )
  }

  const idVerification = vendorData.id_verification

  const summary = `${idVerification.full_name || 'N/A'} - ${idVerification.document_number || 'N/A'}`

  return (
    <CollapsibleSection title={t('common:extractedInformation')} summary={summary}>
      <Box className={styles.gridItems}>
        {idVerification.full_name && <GridItem name={t('common:fullName')} value={idVerification.full_name} />}
        {idVerification.first_name && <GridItem name={t('common:firstName')} value={idVerification.first_name} />}
        {idVerification.last_name && <GridItem name={t('common:lastName')} value={idVerification.last_name} />}
        {idVerification.date_of_birth && <GridItem name={t('common:dateOfBirth')} value={idVerification.date_of_birth} />}
        {idVerification.age && <GridItem name={t('common:age')} value={idVerification.age} />}
        {idVerification.gender && <GridItem name={t('common:gender')} value={idVerification.gender} />}
        {idVerification.document_number && <GridItem name={t('common:documentNumber')} value={idVerification.document_number} />}
        {idVerification.document_type && <GridItem name={t('common:documentType')} value={idVerification.document_type} />}
        {idVerification.nationality && <GridItem name={t('common:nationality')} value={idVerification.nationality} />}
        {idVerification.issuing_state_name && <GridItem name={t('common:issuingState')} value={idVerification.issuing_state_name} />}
        {idVerification.expiration_date && <GridItem name={t('common:expirationDate')} value={idVerification.expiration_date} />}
        {idVerification.date_of_issue && <GridItem name={t('common:dateOfIssue')} value={idVerification.date_of_issue} />}
        {idVerification.place_of_birth && <GridItem name={t('common:placeOfBirth')} value={idVerification.place_of_birth} />}
        {idVerification.formatted_address && <GridItem name={t('common:address')} value={idVerification.formatted_address} />}
      </Box>
    </CollapsibleSection>
  )
}
